var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 50,
    viewBox: "0 0 37 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 25L2.68451 2.73438C2.87289 1.17188 4.15392 0 5.67985 0H21.5608C22.9737 0 24.1135 1.18164 24.1135 2.64648C24.1135 2.95898 24.057 3.28125 23.9533 3.57422L19.5922 15.625H32.7133C34.616 15.625 36.1702 17.2266 36.1702 19.209C36.1702 19.9316 35.963 20.6348 35.5674 21.2305L17.4634 48.6719C16.9077 49.5117 15.994 50.0098 15.0238 50.0098H14.7507C13.2718 50.0098 12.0662 48.7598 12.0662 47.2266C12.0662 47.002 12.0944 46.7773 12.1509 46.5527L16.578 28.125H3.01418C1.34696 28.125 0 26.7285 0 25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlash);
export default __webpack_public_path__ + "static/media/flash.214d934f5614f2fe2137b12c113e3a69.svg";
export { ForwardRef as ReactComponent };